import type { Candidate } from '../../../../shared/types/routes/auth/v2';

import styles from '../Login.module.less';

export type MethodsStepProps = {
  org: Candidate;
};

const MethodsStep = ({ org }: MethodsStepProps) => (
  <div className={styles.card}>
    <h1 className={styles.heading}>{org.organizationName}</h1>
    <p className={styles.placeholder} data-test-id="methods-step">
      Sign-in methods for {org.organizationName} are coming next.
    </p>
  </div>
);

export default MethodsStep;
